import { useEffect } from "react";
import { useLocation } from "wouter";
import {
  GOOGLE_PREFERRED_SOURCES_SCRIPT_URL,
  shouldLoadGooglePreferredSources,
} from "@shared/googlePreferredSources";

const GOOGLE_PREFERRED_SOURCES_SCRIPT_ID = "google-preferred-sources-script";

export function GooglePreferredSourcesGate() {
  const [location] = useLocation();
  const enabled = shouldLoadGooglePreferredSources(location);

  useEffect(() => {
    if (!enabled || typeof document === "undefined") return;

    let frame = 0;
    let script: HTMLScriptElement | null = null;
    let cancelled = false;

    const loadWhenHostExists = () => {
      if (cancelled) return;

      const host = document.querySelector("[google-add-preferred-source-btn]");
      if (!host) {
        frame = window.requestAnimationFrame(loadWhenHostExists);
        return;
      }

      document.getElementById(GOOGLE_PREFERRED_SOURCES_SCRIPT_ID)?.remove();
      script = document.createElement("script");
      script.id = GOOGLE_PREFERRED_SOURCES_SCRIPT_ID;
      script.src = GOOGLE_PREFERRED_SOURCES_SCRIPT_URL;
      script.async = true;
      document.head.appendChild(script);
    };

    frame = window.requestAnimationFrame(loadWhenHostExists);

    return () => {
      cancelled = true;
      window.cancelAnimationFrame(frame);
      script?.remove();
    };
  }, [enabled, location]);

  return null;
}

export function GooglePreferredSourcesButton({
  leadIn,
  compact = false,
  className = "",
}: {
  leadIn?: string;
  compact?: boolean;
  className?: string;
}) {
  return (
    <div
      className={`${compact ? "max-w-xs" : "rounded-2xl border border-white/10 bg-white/[0.025] p-6 sm:p-7"} ${className}`}
      data-google-preferred-sources-placement={compact ? "home-footer" : "editorial"}
    >
      {leadIn ? (
        <p className={`${compact ? "mb-3 text-xs" : "mb-4 text-sm"} font-semibold leading-6 text-slate-400`}>
          {leadIn}
        </p>
      ) : null}
      <div {...{ "google-add-preferred-source-btn": "" }} data-theme="dark" />
    </div>
  );
}
